import { render, staticRenderFns } from "./case-update-import-list.vue?vue&type=template&id=d0dd45d4&scoped=true"
import script from "./case-update-import-list.vue?vue&type=script&lang=ts"
export * from "./case-update-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dd45d4",
  null
  
)

export default component.exports